import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function wait(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export const displayName = (firstName?: string, lastName?: string, fallback: string = "N/A") => {
  return [firstName, lastName].filter(Boolean).join(" ") || fallback
}